
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as indexRhLHZjX5joMeta } from "/codebuild/output/src2929202082/src/pages/index.vue?macro=true";
import { default as aboutyFHMplJOeOMeta } from "/codebuild/output/src2929202082/src/pages/about.vue?macro=true";
import { default as dataAIOuW401l3Meta } from "/codebuild/output/src2929202082/src/pages/account-settings/data.vue?macro=true";
import { default as manage_45subscriptionrej63Z1uMDMeta } from "/codebuild/output/src2929202082/src/pages/account-settings/manage-subscription.vue?macro=true";
import { default as positioningfTxeolwqccMeta } from "/codebuild/output/src2929202082/src/pages/account-settings/positioning.vue?macro=true";
import { default as privacyQg36iZE5NoMeta } from "/codebuild/output/src2929202082/src/pages/account-settings/privacy.vue?macro=true";
import { default as remove_45accountZbFJYwezgIMeta } from "/codebuild/output/src2929202082/src/pages/account-settings/remove-account.vue?macro=true";
import { default as statue0UuFvIRukcMeta } from "/codebuild/output/src2929202082/src/pages/account-settings/statue.vue?macro=true";
import { default as support0ckUzGIOQHMeta } from "/codebuild/output/src2929202082/src/pages/account-settings/support.vue?macro=true";
import { default as account_45settingsivcfD1FHXDMeta } from "/codebuild/output/src2929202082/src/pages/account-settings.vue?macro=true";
import { default as activate_45accountxMT6ZHbjsdMeta } from "/codebuild/output/src2929202082/src/pages/activate-account.vue?macro=true";
import { default as companyavld86Ym0WMeta } from "/codebuild/output/src2929202082/src/pages/admin/company.vue?macro=true";
import { default as consentszbYWCsfJ1MMeta } from "/codebuild/output/src2929202082/src/pages/admin/consents.vue?macro=true";
import { default as leads72oQWcEhAyMeta } from "/codebuild/output/src2929202082/src/pages/admin/leads.vue?macro=true";
import { default as paymentsByF9cZXHexMeta } from "/codebuild/output/src2929202082/src/pages/admin/payments.vue?macro=true";
import { default as premiumEoA6CW6xF1Meta } from "/codebuild/output/src2929202082/src/pages/admin/premium.vue?macro=true";
import { default as profilesC5UpRN9HDyMeta } from "/codebuild/output/src2929202082/src/pages/admin/profiles.vue?macro=true";
import { default as usersmMpgkQyrWkMeta } from "/codebuild/output/src2929202082/src/pages/admin/users.vue?macro=true";
import { default as change_45passwordLyuOk7II7KMeta } from "/codebuild/output/src2929202082/src/pages/change-password.vue?macro=true";
import { default as _91id_93NoPaWJlAuOMeta } from "/codebuild/output/src2929202082/src/pages/chat/[id].vue?macro=true";
import { default as ai_46clientYPKTwwP4SLMeta } from "/codebuild/output/src2929202082/src/pages/chat/ai.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/codebuild/output/src2929202082/src/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as indexpeqpUsgQioMeta } from "/codebuild/output/src2929202082/src/pages/chat/index.vue?macro=true";
import { default as _91id_93zyvQtwcFQEMeta } from "/codebuild/output/src2929202082/src/pages/client/profile/[id].vue?macro=true";
import { default as indexgGmrmyplAZMeta } from "/codebuild/output/src2929202082/src/pages/client/profile/index.vue?macro=true";
import { default as _91id_93niUX42VWSuMeta } from "/codebuild/output/src2929202082/src/pages/contacts/[id].vue?macro=true";
import { default as indexp0PJGOVn44Meta } from "/codebuild/output/src2929202082/src/pages/contacts/index.vue?macro=true";
import { default as contacts8sbSQzAfgmMeta } from "/codebuild/output/src2929202082/src/pages/contacts.vue?macro=true";
import { default as _91userId_930UBqRs76v0Meta } from "/codebuild/output/src2929202082/src/pages/delete-mailing/[email]/[userId].vue?macro=true";
import { default as indexdOzpCdYb9LMeta } from "/codebuild/output/src2929202082/src/pages/login/index.vue?macro=true";
import { default as register_45successv0qsWZtdrkMeta } from "/codebuild/output/src2929202082/src/pages/login/register-success.vue?macro=true";
import { default as loginSEakt2G9rbMeta } from "/codebuild/output/src2929202082/src/pages/login.vue?macro=true";
import { default as logoutjjgQzm3jexMeta } from "/codebuild/output/src2929202082/src/pages/logout.vue?macro=true";
import { default as consentsW3Ve7KUc7jMeta } from "/codebuild/output/src2929202082/src/pages/manager/consents.vue?macro=true";
import { default as integrationsz3UjuoUCftMeta } from "/codebuild/output/src2929202082/src/pages/manager/integrations.vue?macro=true";
import { default as leadsGWOHqDFdj0Meta } from "/codebuild/output/src2929202082/src/pages/manager/leads.vue?macro=true";
import { default as paymentsuYp2xynXtTMeta } from "/codebuild/output/src2929202082/src/pages/manager/payments.vue?macro=true";
import { default as profile4nwqzoxFCNMeta } from "/codebuild/output/src2929202082/src/pages/manager/profile.vue?macro=true";
import { default as teamw45JyS0DPtMeta } from "/codebuild/output/src2929202082/src/pages/manager/team.vue?macro=true";
import { default as indexP6CbZMvkIVMeta } from "/codebuild/output/src2929202082/src/pages/marketplace/index.vue?macro=true";
import { default as _91catId_93_46clientnf029yOJ3VMeta } from "/codebuild/output/src2929202082/src/pages/marketplace/search/[catId].client.vue?macro=true";
import { default as marketplaceeeFW6cGNqRMeta } from "/codebuild/output/src2929202082/src/pages/marketplace.vue?macro=true";
import { default as subscribe2Id1ycQKKCMeta } from "/codebuild/output/src2929202082/src/pages/newsletter/subscribe.vue?macro=true";
import { default as find_46clientSh54beIYCdMeta } from "/codebuild/output/src2929202082/src/pages/orders/find.client.vue?macro=true";
import { default as my_46clientETro7Ss94CMeta } from "/codebuild/output/src2929202082/src/pages/orders/my.client.vue?macro=true";
import { default as privacy8AiJS7dGSMMeta } from "/codebuild/output/src2929202082/src/pages/privacy.vue?macro=true";
import { default as indexJYAFlKheByMeta } from "/codebuild/output/src2929202082/src/pages/recover/index.vue?macro=true";
import { default as successr9j9lz1kedMeta } from "/codebuild/output/src2929202082/src/pages/register/success.vue?macro=true";
import { default as _91id_93HveEvk93LeMeta } from "/codebuild/output/src2929202082/src/pages/sales/profile/[id].vue?macro=true";
import { default as indexVk38K2qVtXMeta } from "/codebuild/output/src2929202082/src/pages/sales/profile/index.vue?macro=true";
import { default as statueTzqeJq3Hc5Meta } from "/codebuild/output/src2929202082/src/pages/statue.vue?macro=true";
import { default as successYeQat4KjZuMeta } from "/codebuild/output/src2929202082/src/pages/subscription/success.vue?macro=true";
import { default as component_45stubeDGZ6f7k48Meta } from "/codebuild/output/src2929202082/src/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubeDGZ6f7k48 } from "/codebuild/output/src2929202082/src/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: indexRhLHZjX5joMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/index.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    meta: aboutyFHMplJOeOMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/about.vue")
  },
  {
    name: "about___pl",
    path: "/pl/about",
    meta: aboutyFHMplJOeOMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/about.vue")
  },
  {
    name: "account-settings___en",
    path: "/en/account-settings",
    meta: account_45settingsivcfD1FHXDMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___en",
    path: "data",
    component: () => import("/codebuild/output/src2929202082/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___en",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src2929202082/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___en",
    path: "positioning",
    component: () => import("/codebuild/output/src2929202082/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___en",
    path: "privacy",
    component: () => import("/codebuild/output/src2929202082/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___en",
    path: "remove-account",
    component: () => import("/codebuild/output/src2929202082/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___en",
    path: "statue",
    component: () => import("/codebuild/output/src2929202082/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___en",
    path: "support",
    component: () => import("/codebuild/output/src2929202082/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "account-settings___pl",
    path: "/pl/account-settings",
    meta: account_45settingsivcfD1FHXDMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___pl",
    path: "data",
    component: () => import("/codebuild/output/src2929202082/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___pl",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src2929202082/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___pl",
    path: "positioning",
    component: () => import("/codebuild/output/src2929202082/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___pl",
    path: "privacy",
    component: () => import("/codebuild/output/src2929202082/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___pl",
    path: "remove-account",
    component: () => import("/codebuild/output/src2929202082/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___pl",
    path: "statue",
    component: () => import("/codebuild/output/src2929202082/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___pl",
    path: "support",
    component: () => import("/codebuild/output/src2929202082/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "activate-account___en",
    path: "/en/activate-account",
    meta: activate_45accountxMT6ZHbjsdMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/activate-account.vue")
  },
  {
    name: "activate-account___pl",
    path: "/pl/activate-account",
    meta: activate_45accountxMT6ZHbjsdMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/activate-account.vue")
  },
  {
    name: "admin-company___en",
    path: "/en/admin/company",
    meta: companyavld86Ym0WMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/admin/company.vue")
  },
  {
    name: "admin-company___pl",
    path: "/pl/admin/company",
    meta: companyavld86Ym0WMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/admin/company.vue")
  },
  {
    name: "admin-consents___en",
    path: "/en/admin/consents",
    meta: consentszbYWCsfJ1MMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/admin/consents.vue")
  },
  {
    name: "admin-consents___pl",
    path: "/pl/admin/consents",
    meta: consentszbYWCsfJ1MMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/admin/consents.vue")
  },
  {
    name: "admin-leads___en",
    path: "/en/admin/leads",
    meta: leads72oQWcEhAyMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/admin/leads.vue")
  },
  {
    name: "admin-leads___pl",
    path: "/pl/admin/leads",
    meta: leads72oQWcEhAyMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/admin/leads.vue")
  },
  {
    name: "admin-payments___en",
    path: "/en/admin/payments",
    meta: paymentsByF9cZXHexMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/admin/payments.vue")
  },
  {
    name: "admin-payments___pl",
    path: "/pl/admin/payments",
    meta: paymentsByF9cZXHexMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/admin/payments.vue")
  },
  {
    name: "admin-premium___en",
    path: "/en/admin/premium",
    meta: premiumEoA6CW6xF1Meta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/admin/premium.vue")
  },
  {
    name: "admin-premium___pl",
    path: "/pl/admin/premium",
    meta: premiumEoA6CW6xF1Meta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/admin/premium.vue")
  },
  {
    name: "admin-profiles___en",
    path: "/en/admin/profiles",
    meta: profilesC5UpRN9HDyMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-profiles___pl",
    path: "/pl/admin/profiles",
    meta: profilesC5UpRN9HDyMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-users___en",
    path: "/en/admin/users",
    meta: usersmMpgkQyrWkMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/admin/users.vue")
  },
  {
    name: "admin-users___pl",
    path: "/pl/admin/users",
    meta: usersmMpgkQyrWkMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/admin/users.vue")
  },
  {
    name: "change-password___en",
    path: "/en/change-password",
    meta: change_45passwordLyuOk7II7KMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/change-password.vue")
  },
  {
    name: "change-password___pl",
    path: "/pl/change-password",
    meta: change_45passwordLyuOk7II7KMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/change-password.vue")
  },
  {
    name: "chat-id___en",
    path: "/en/chat/:id()",
    meta: _91id_93NoPaWJlAuOMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/chat/[id].vue")
  },
  {
    name: "chat-id___pl",
    path: "/pl/chat/:id()",
    meta: _91id_93NoPaWJlAuOMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/chat/[id].vue")
  },
  {
    name: "chat-ai___en",
    path: "/en/chat/ai",
    meta: ai_46clientYPKTwwP4SLMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src2929202082/src/pages/chat/ai.client.vue"))
  },
  {
    name: "chat-ai___pl",
    path: "/pl/chat/ai",
    meta: ai_46clientYPKTwwP4SLMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src2929202082/src/pages/chat/ai.client.vue"))
  },
  {
    name: "chat___en",
    path: "/en/chat",
    meta: indexpeqpUsgQioMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/chat/index.vue")
  },
  {
    name: "chat___pl",
    path: "/pl/chat",
    meta: indexpeqpUsgQioMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/chat/index.vue")
  },
  {
    name: "client-profile-id___en",
    path: "/en/client/profile/:id()",
    meta: _91id_93zyvQtwcFQEMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile-id___pl",
    path: "/pl/client/profile/:id()",
    meta: _91id_93zyvQtwcFQEMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile___en",
    path: "/en/client/profile",
    meta: indexgGmrmyplAZMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/client/profile/index.vue")
  },
  {
    name: "client-profile___pl",
    path: "/pl/client/profile",
    meta: indexgGmrmyplAZMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/client/profile/index.vue")
  },
  {
    name: contacts8sbSQzAfgmMeta?.name,
    path: "/en/contacts",
    meta: contacts8sbSQzAfgmMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___en",
    path: ":id()",
    meta: _91id_93niUX42VWSuMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___en",
    path: "",
    meta: indexp0PJGOVn44Meta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: contacts8sbSQzAfgmMeta?.name,
    path: "/pl/contacts",
    meta: contacts8sbSQzAfgmMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___pl",
    path: ":id()",
    meta: _91id_93niUX42VWSuMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___pl",
    path: "",
    meta: indexp0PJGOVn44Meta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: "delete-mailing-email-userId___en",
    path: "/en/delete-mailing/:email()/:userId()",
    meta: _91userId_930UBqRs76v0Meta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "delete-mailing-email-userId___pl",
    path: "/pl/delete-mailing/:email()/:userId()",
    meta: _91userId_930UBqRs76v0Meta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexRhLHZjX5joMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    meta: indexRhLHZjX5joMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/index.vue")
  },
  {
    name: loginSEakt2G9rbMeta?.name,
    path: "/en/login",
    component: () => import("/codebuild/output/src2929202082/src/pages/login.vue"),
    children: [
  {
    name: "login___en",
    path: "",
    meta: indexdOzpCdYb9LMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___en",
    path: "register-success",
    meta: register_45successv0qsWZtdrkMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: loginSEakt2G9rbMeta?.name,
    path: "/pl/login",
    component: () => import("/codebuild/output/src2929202082/src/pages/login.vue"),
    children: [
  {
    name: "login___pl",
    path: "",
    meta: indexdOzpCdYb9LMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___pl",
    path: "register-success",
    meta: register_45successv0qsWZtdrkMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: "logout___en",
    path: "/en/logout",
    meta: logoutjjgQzm3jexMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/logout.vue")
  },
  {
    name: "logout___pl",
    path: "/pl/logout",
    meta: logoutjjgQzm3jexMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/logout.vue")
  },
  {
    name: "manager-consents___en",
    path: "/en/manager/consents",
    meta: consentsW3Ve7KUc7jMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/manager/consents.vue")
  },
  {
    name: "manager-consents___pl",
    path: "/pl/manager/consents",
    meta: consentsW3Ve7KUc7jMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/manager/consents.vue")
  },
  {
    name: "manager-integrations___en",
    path: "/en/manager/integrations",
    meta: integrationsz3UjuoUCftMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-integrations___pl",
    path: "/pl/manager/integrations",
    meta: integrationsz3UjuoUCftMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-leads___en",
    path: "/en/manager/leads",
    meta: leadsGWOHqDFdj0Meta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/manager/leads.vue")
  },
  {
    name: "manager-leads___pl",
    path: "/pl/manager/leads",
    meta: leadsGWOHqDFdj0Meta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/manager/leads.vue")
  },
  {
    name: "manager-payments___en",
    path: "/en/manager/payments",
    meta: paymentsuYp2xynXtTMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/manager/payments.vue")
  },
  {
    name: "manager-payments___pl",
    path: "/pl/manager/payments",
    meta: paymentsuYp2xynXtTMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/manager/payments.vue")
  },
  {
    name: "manager-profile___en",
    path: "/en/manager/profile",
    meta: profile4nwqzoxFCNMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/manager/profile.vue")
  },
  {
    name: "manager-profile___pl",
    path: "/pl/manager/profile",
    meta: profile4nwqzoxFCNMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/manager/profile.vue")
  },
  {
    name: "manager-team___en",
    path: "/en/manager/team",
    meta: teamw45JyS0DPtMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/manager/team.vue")
  },
  {
    name: "manager-team___pl",
    path: "/pl/manager/team",
    meta: teamw45JyS0DPtMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/manager/team.vue")
  },
  {
    name: marketplaceeeFW6cGNqRMeta?.name,
    path: "/en/marketplace",
    meta: marketplaceeeFW6cGNqRMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___en",
    path: "",
    component: () => import("/codebuild/output/src2929202082/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___en",
    path: "search/:catId()",
    meta: _91catId_93_46clientnf029yOJ3VMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src2929202082/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: marketplaceeeFW6cGNqRMeta?.name,
    path: "/pl/marketplace",
    meta: marketplaceeeFW6cGNqRMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___pl",
    path: "",
    component: () => import("/codebuild/output/src2929202082/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___pl",
    path: "search/:catId()",
    meta: _91catId_93_46clientnf029yOJ3VMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src2929202082/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: "newsletter-subscribe___en",
    path: "/en/newsletter/subscribe",
    meta: subscribe2Id1ycQKKCMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "newsletter-subscribe___pl",
    path: "/pl/newsletter/subscribe",
    meta: subscribe2Id1ycQKKCMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "orders-find___en",
    path: "/en/orders/find",
    meta: find_46clientSh54beIYCdMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src2929202082/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-find___pl",
    path: "/pl/orders/find",
    meta: find_46clientSh54beIYCdMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src2929202082/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-my___en",
    path: "/en/orders/my",
    meta: my_46clientETro7Ss94CMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src2929202082/src/pages/orders/my.client.vue"))
  },
  {
    name: "orders-my___pl",
    path: "/pl/orders/my",
    meta: my_46clientETro7Ss94CMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src2929202082/src/pages/orders/my.client.vue"))
  },
  {
    name: "privacy___en",
    path: "/en/privacy",
    meta: privacy8AiJS7dGSMMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/privacy.vue")
  },
  {
    name: "privacy___pl",
    path: "/pl/privacy",
    meta: privacy8AiJS7dGSMMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/privacy.vue")
  },
  {
    name: "recover___en",
    path: "/en/recover",
    meta: indexJYAFlKheByMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/recover/index.vue")
  },
  {
    name: "recover___pl",
    path: "/pl/recover",
    meta: indexJYAFlKheByMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/recover/index.vue")
  },
  {
    name: "register-success___en",
    path: "/en/register/success",
    component: () => import("/codebuild/output/src2929202082/src/pages/register/success.vue")
  },
  {
    name: "register-success___pl",
    path: "/pl/register/success",
    component: () => import("/codebuild/output/src2929202082/src/pages/register/success.vue")
  },
  {
    name: "sales-profile-id___en",
    path: "/en/sales/profile/:id()",
    meta: _91id_93HveEvk93LeMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile-id___pl",
    path: "/pl/sales/profile/:id()",
    meta: _91id_93HveEvk93LeMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile___en",
    path: "/en/sales/profile",
    meta: indexVk38K2qVtXMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/sales/profile/index.vue")
  },
  {
    name: "sales-profile___pl",
    path: "/pl/sales/profile",
    meta: indexVk38K2qVtXMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/sales/profile/index.vue")
  },
  {
    name: "statue___en",
    path: "/en/statue",
    meta: statueTzqeJq3Hc5Meta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/statue.vue")
  },
  {
    name: "statue___pl",
    path: "/pl/statue",
    meta: statueTzqeJq3Hc5Meta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/statue.vue")
  },
  {
    name: "subscription-success___en",
    path: "/en/subscription/success",
    meta: successYeQat4KjZuMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/subscription/success.vue")
  },
  {
    name: "subscription-success___pl",
    path: "/pl/subscription/success",
    meta: successYeQat4KjZuMeta || {},
    component: () => import("/codebuild/output/src2929202082/src/pages/subscription/success.vue")
  },
  {
    name: component_45stubeDGZ6f7k48Meta?.name,
    path: "/old-page",
    component: component_45stubeDGZ6f7k48
  }
]